var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import PropTypes from "prop-types";
import React, { Component } from "react";
import Scrollbars from "react-custom-scrollbars";
import { ModalCloseButton } from "./../../ui-components";
import { getEmojiGroups } from "../constants";
import { INSERT_EMOJI_MODAL, INSERT_EMOJI_MODAL_LIST_ITEM } from "../dataHooks";
import JoyPixelsIcon from "../icons/JoyPixelsIcon";
import styles from "../statics/styles/emoji-preview-modal.scss";
import { getGroupEmojis } from "../utils";
class EmojiPreviewModal extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onNavIconClicked", (group) => {
      this.setState({ activeGroup: group });
      this.groupRefs[group.category].current.scrollIntoView({
        behavior: "smooth"
      });
    });
    __publicField(this, "renderNavIcons", (activeGroup) => {
      const { t } = this.props;
      return getEmojiGroups(t).map((group, index) => {
        const color = activeGroup.category === group.category ? "#42A5F5" : "#bdbdbd";
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: `emoji-group-${index}`,
            role: "button",
            "data-hook": "emoji-group-" + index,
            onKeyPress: null,
            tabIndex: 0,
            className: styles.emojiPreviewModal_nav_icon,
            onClick: this.onNavIconClicked.bind(this, group),
            style: { color }
          },
          group.icon
        );
      });
    });
    __publicField(this, "onScroll", (event) => {
      const { scrollTop } = event.srcElement;
      const { t } = this.props;
      const categoryScrollTop = getEmojiGroups(t).find(({ top }) => scrollTop < top);
      this.setState({ activeGroup: categoryScrollTop });
    });
    __publicField(this, "renderEmojis", () => this.emojiGroupsCategories.map((category) => {
      const emojis = getGroupEmojis(category) || [];
      const emojisElements = emojis.map((emoji, index) => /* @__PURE__ */ React.createElement(
        "div",
        {
          role: "button",
          "data-hook": `${INSERT_EMOJI_MODAL_LIST_ITEM} emoji-${index}`,
          tabIndex: 0,
          className: styles.emojiPreviewModal_emoji,
          key: `emojis-${category}-${index}`,
          onClick: this.getBoundOnClick(emoji),
          onKeyPress: this.getBoundKeyPress(emoji)
        },
        emoji
      ));
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.groupRefs[category],
          key: `anchor-${category}`,
          className: styles.emojiPreviewModal_emoji_group
        },
        emojisElements
      );
    }));
    const { t } = props;
    this.scrollbarRef = "";
    const groups = getEmojiGroups(t);
    this.groupRefs = {};
    groups.map(({ category }) => this.groupRefs[category] = React.createRef());
    this.emojiGroupsCategories = groups.map(({ category }) => category);
    this.state = {
      activeGroup: groups[0]
    };
  }
  getBoundOnClick(emoji) {
    return () => this.addEmoji(emoji);
  }
  getBoundKeyPress(emoji) {
    return (e) => {
      if (e.key === "Enter") {
        this.addEmoji(emoji);
      }
    };
  }
  addEmoji(emoji) {
    this.props.onAdd(emoji);
  }
  render() {
    const { activeGroup } = this.state;
    const { showCloseButton, closeModal } = this.props;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": INSERT_EMOJI_MODAL }, /* @__PURE__ */ React.createElement("div", { className: styles.emojiPreviewModal_headerTitle }, /* @__PURE__ */ React.createElement("div", null, activeGroup.title), /* @__PURE__ */ React.createElement("div", { className: styles.emojiPreviewModal_JoyPixelsIcon }, /* @__PURE__ */ React.createElement(JoyPixelsIcon, null)), showCloseButton && /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal })), /* @__PURE__ */ React.createElement("div", { className: styles.emojiPreviewModal_emojis_groups_container }, /* @__PURE__ */ React.createElement(
      Scrollbars,
      {
        ref: (ref) => {
          this.scrollbarRef = ref;
        },
        renderThumbVertical: () => /* @__PURE__ */ React.createElement("div", { className: styles.emojiPreviewModal_scrollbar_thumb }),
        onScroll: this.onScroll
      },
      this.renderEmojis()
    )), /* @__PURE__ */ React.createElement("div", { className: styles.emojiPreviewModal_emoji_icons_container }, this.renderNavIcons(activeGroup)));
  }
}
EmojiPreviewModal.propTypes = {
  t: PropTypes.func,
  onAdd: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closeModal: PropTypes.func
};
export {
  EmojiPreviewModal as default
};
//# sourceMappingURL=emojiPreviewModal.js.map
